<template>
    <card class="card-user">
        <p class="card-text"></p>
        <div class="author">
            <div class="block block-one"></div>
            <div class="block block-two"></div>
            <div class="block block-three"></div>
            <div class="block block-four"></div>
            <font-awesome-icon :icon="['fal','users-class']" size="6x"></font-awesome-icon>

            <h5 class="title" style="margin-top:1em;">{{ classroom.name }}</h5>
            <p class="description">Classroom</p>
        </div>
        <p></p>
        <div class="card-description">
            <h5 class="title" v-if="loading.classroom">Loading classroom..</h5>
            <classroom-form v-if="loading.classroom === false" :classroom="classroom"
                            @updated="classroom = arguments[0]"/>
        </div>
        <div class="card-footer text-center">
            <hr>
            <base-button type="default" @click="$router.push('/school')">
                <font-awesome-icon :icon="['fal','chevron-left']" size="lg"
                                   style="margin-right: 1em;"></font-awesome-icon>
                Back to school
            </base-button>

            <base-button v-if="classroom.converted === false" @click="convertClassroom" :loading="converting"
                         type="primary">
                <font-awesome-icon v-if="converting === false" :icon="['fal','sync']" size="lg"
                                   style="margin-right: 1em;"></font-awesome-icon>
                Convert
            </base-button>

        </div>
    </card>
</template>
<script>
    import ClassroomForm from "./ClassroomForm"
    import swal from "sweetalert2";
    import axios from "axios";

    export default {
        name: 'classroom-info-card',
        components: {ClassroomForm},
        props: {
            classroom: {},
            loading: {}
        },
        data() {
            return {
                converting: false,
            }
        },
        methods: {
            convertClassroom() {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You're about to convert this classroom to Chol/Kodesh/Other.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                }).then((result) => {
                    if (result.value) {
                        swal.fire({
                            title: 'Are you sure?',
                            text: "We just want to confirm once more! Do you want to convert this classroom?",
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes'
                        }).then((result) => {
                            if (result.value) {
                                this.converting = true;
                                axios({
                                    url: this.baseAPIURL + 'classroom/' + this.classroom.id + '/convert',
                                    method: 'POST',
                                    headers: {
                                        'Access-Control-Allow-Origin': '*',
                                        'Content-Type': 'application/json',
                                    },
                                }).then(() => {
                                    this.$notify({
                                        message: 'You can continue using the system. It will switch over automatically within a few minutes!',
                                        type: "success",
                                        duration: 0,
                                        icon: "fal fa-check",
                                        title: "Conversion started!"
                                    });
                                })
                                    .finally(() => {
                                        this.converting = false;
                                    })
                            }
                        });
                    }
                });
            }
        }
    }
</script>
<style>
    .white-content .el-table table > tbody > tr > td {
        padding: 4px 2px;
    }

</style>
